export class SupplierOrderLineModel {
    ifsId: string;
    orderNo: number;
    partNo: number;
    description: string;
    plannedDate: Date;
    qty: number;
    stdQty: number; // amount per pallet
    units: string;
    status: string;
    printed: string;
}



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/models/supplier-order-line.model.ts